import { sendErrorMetric } from "@expert/cloudwatch-metrics";

/**
 * Canonical set of `action` label values for the `ChatRuntimeError` Grafana metric
 * (`exwo_Error_total{errorType="ChatRuntimeError"}`). Emissions live next to every
 * `error`/`fatal` log in the chat integration. See `docs/chat-runtime-errors-metric.md`.
 */
export const CHAT_RUNTIME_ACTIONS = {
    /** ChatJS global config threw at chat SDK boot. Blocks all chat. */
    configureChatJsFailed: "configure_chatjs_failed",
    /** `initializeConnection` couldn't establish the ChatJS session for a contact. */
    connectionInitFailed: "connection_init_failed",
    /** Cache insert or `onMessageAdded` callback threw after decrypt. Downstream code bug. */
    messageProcessFailed: "message_process_failed",
    /** React Query send mutation failed after retries. Excludes `ContactEndedError`. */
    messageSendFailed: "message_send_failed",
    /** Message body could not be decrypted (missing partner OR key/IV rejected). */
    messageDecryptFailed: "message_decrypt_failed",
    /** Contact attribute decrypt failed (missing partner OR key/IV rejected). */
    attributeDecryptFailed: "attribute_decrypt_failed",
    /** REST call to `/api/chat-metadata` failed (rehydrate, session-id, or close-reason update). */
    metadataApiFailed: "metadata_api_failed",
} as const;

export type ChatRuntimeAction = (typeof CHAT_RUNTIME_ACTIONS)[keyof typeof CHAT_RUNTIME_ACTIONS];

export function emitChatRuntimeError(action: ChatRuntimeAction, partner?: string): void {
    void sendErrorMetric("ChatRuntimeError", {
        channel: "chat",
        communicationProvider: "amazon-connect",
        action,
        ...(partner && { partner }),
    });
}
